import React, { memo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useSelector } from "react-redux";
import PageNotFound from "../pages/PageNotFound";

const UserRoute = memo(function UserRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);
  const { lang } = useSelector((state) => state?.langProvider);

  useEffect(() => {
    if (session?.status === "unauthorized") {
      navigate("/login");
    } else if (
      session?.status === "authorized" &&
      ["admin", "organization"].includes(session?.user?.role?.toLowerCase())
    ) {
      if (session?.user?.role?.toLowerCase() === "admin") {
        navigate(`/${lang}/admin/events`);
      } else if (session?.user?.role?.toLowerCase() === "organization") {
        // navigate(`/${lang}/user/events`);
      }
    }
  }, [session?.status, session?.user?.role?.toLowerCase(), navigate]);

  if (session?.status === "loading") {
    return <LoadingFallback />;
  }

  return session?.status === "authorized" &&
    session?.user?.role?.toLowerCase() === "user" ? (
    <>{children}</>
  ) : (
    <PageNotFound />
  );
});

export default UserRoute;
